<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Options-->
				<div class="OptionsDiv">
					<label>Facility</label>
					<p-dropdown
						style="margin-left: 5px"
						[options]="lstFacility"
						[(ngModel)]="SelectedFacility"
						optionLabel="FacilityName"
						[filter]="true"
						filterBy="FacilityName"
						[showClear]="false"
						placeholder="Select a Facility"
					>
						<ng-template pTemplate="selectedItem">
							<div *ngIf="SelectedFacility">
								<div class="form-control NoBorder" style="text-align: left">
									{{ SelectedFacility.FacilityName }}
								</div>
							</div>
						</ng-template>
						<ng-template let-FacilityItem pTemplate="item">
							<div>
								<div class="form-control NoBorder" style="text-align: left">
									{{ FacilityItem.FacilityName }}
								</div>
							</div>
						</ng-template>
					</p-dropdown>
				</div>

				<div *ngIf="lstWaitingLookup.length == 0">
					<h4>...No Visitors waiting for Offender Lookup</h4>
					<label>(After a visitor has entered their information they will show up in a grid of people waiting approval)</label>
				</div>

				<!--Pick a person/station that is waiting for the lookup to finish-->
				<div *ngIf="lstWaitingLookup.length > 0">
					<p-dataView [value]="lstWaitingLookup" [paginator]="true" [rows]="10" layout="grid">
						<ng-template pTemplate="header">
							<div class="flex flex-column md:flex-row md:justify-content-between">
								<!-- <p-dropdown [options]="sortOptions" [(ngModel)]="sortKey" placeholder="Sort By Price" (onChange)="onSortChange($event)" styleClass="mb-2 md:mb-0"></p-dropdown>
                                <span class="p-input-icon-left mb-2 md:mb-0">
                                    <i class="pi pi-search"></i>
                                    <input type="search" pInputText placeholder="Search by Name" (input)="dv.filter($event.target.value)">
                                </span> -->
								<!-- <p-dataViewLayoutOptions></p-dataViewLayoutOptions> -->
							</div>
						</ng-template>
						<!-- <ng-template let-person pTemplate="listItem">
                            <div>
                                <label>{{person.ID}}</label>
                            </div>
                        </ng-template> -->
						<ng-template let-person pTemplate="gridItem">
							<div class="col-12 md:col-4">
								<div class="PersonItemGrid" (click)="onPersonClick(person)">
									<div class="CenterDiv">
										<img class="IMG" [src]="person.Image" />
									</div>
									<div class="PersonInfoGrid">
										<label>ID:</label>
										<label>{{ person.ID }}</label>

										<label>Name:</label>
										<label>{{ person.FirstName }} {{ person.LastName }}</label>
									</div>
								</div>
							</div>
						</ng-template>
					</p-dataView>
				</div>
			</div>
		</div>
	</div>
</div>
